module.exports = __webpack_public_path__ + "static/media/fb2.08b77e6c.png";